// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9dd28d9","687":"1e973711","723":"fcce97bb","749":"a8df195b","952":"f466b1cf"}[chunkId] + ".chunk.js";
};